import { useState } from 'react';
import { api, ApiError } from '../lib/api.ts';
import { Field, Modal } from './ui.tsx';

/** Redefine a própria senha — quem já está logado pode trocar sem informar
 * a senha atual. Derruba as outras sessões abertas (outros dispositivos) e
 * mantém a sessão atual logada. */
export function ChangePasswordModal({ onClose }: { onClose: () => void }) {
  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [error, setError] = useState<string | null>(null);
  const [saving, setSaving] = useState(false);
  const [done, setDone] = useState(false);

  async function save() {
    setError(null);
    if (newPassword.length < 6) {
      setError('A nova senha precisa de ao menos 6 caracteres.');
      return;
    }
    if (newPassword !== confirmPassword) {
      setError('As senhas novas não coincidem.');
      return;
    }
    setSaving(true);
    try {
      await api.post('/auth/change-password', { newPassword });
      setDone(true);
    } catch (err) {
      setError(err instanceof ApiError ? err.message : 'Não foi possível trocar a senha.');
    } finally {
      setSaving(false);
    }
  }

  return (
    <Modal
      title="Redefinir senha"
      onClose={onClose}
      footer={
        done ? (
          <button type="button" className="btn btn-primary" onClick={onClose}>
            Fechar
          </button>
        ) : (
          <>
            <button type="button" className="btn btn-ghost" onClick={onClose}>
              Cancelar
            </button>
            <button
              type="button"
              className="btn btn-primary"
              onClick={() => void save()}
              disabled={saving || !newPassword || !confirmPassword}
            >
              {saving ? 'Salvando…' : 'Redefinir senha'}
            </button>
          </>
        )
      }
    >
      {done ? (
        <p className="text-body">
          Senha redefinida. Suas outras sessões abertas (outros dispositivos/navegadores) foram
          encerradas — esta continua logada normalmente.
        </p>
      ) : (
        <div className="stack">
          <Field label="Nova senha" hint="Mínimo de 6 caracteres.">
            <input
              className="input"
              type="password"
              autoComplete="new-password"
              value={newPassword}
              onChange={(e) => setNewPassword(e.target.value)}
            />
          </Field>

          <Field label="Confirmar nova senha">
            <input
              className="input"
              type="password"
              autoComplete="new-password"
              value={confirmPassword}
              onChange={(e) => setConfirmPassword(e.target.value)}
            />
          </Field>

          {error && (
            <p className="state-error" role="alert">
              {error}
            </p>
          )}
        </div>
      )}
    </Modal>
  );
}
